import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { AboutNg2Component } from './about/aboutNg2.component';
import { SettingsNg2Component } from './settings/settingsNg2.component';
import { RdSAPModule } from '../rdsap/rdsap.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreStateModule } from '../core-state/core-state.module';
import { Configuration, ConfigurationParameters } from '../rdsap-api/configuration';
import { ApiModule } from '../rdsap-api';
import { environment } from '../environments/environment';
import { ErrorInterceptor } from './error.interceptor';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';


// This function is used to configure the API client for the Angular module.
function apiConfigFactory(injector: Injector): Configuration {
  const cookieService = injector.get(CookieService); // Get CookieService from injector
  const token = cookieService.get('authToken'); // Retrieve the token from the cookie

  const params: ConfigurationParameters = {
    username: 'admin',
    password: 'admin',
    basePath: environment.baseApiUrl,
    accessToken: token,
    apiKeys: {
      'X-API-KEY': '',
    },
  };
  return new Configuration(params);
}

// This is the main Angular module for the application.
@NgModule({
  declarations: [
    AboutNg2Component,
    SettingsNg2Component,
    AppComponent,
  ],
  imports: [
    BrowserModule,
    ApiModule.forRoot(() => new Configuration({ basePath: environment.baseApiUrl })), // Provide a default configuration
    HttpClientModule,
    RdSAPModule,
    AppRoutingModule,
    CoreStateModule,
    KeycloakAngularModule,
  ],
  providers: [
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: Configuration,
      useFactory: apiConfigFactory, // provide the configuration factory function here
      deps: [Injector]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (keycloak: KeycloakService) => () => keycloak.init({
        config: {
          url: environment.keycloakUrl,
          realm: 'quidos',
          clientId: environment.clientId
        },
        initOptions: {
          onLoad: 'login-required',
          pkceMethod: 'S256',
          checkLoginIframe: false,
          redirectUri: `${window.location.origin}${window.location.pathname}${window.location.search}`
        }
      }).then(authenticated => {
        if (!authenticated) {
          return keycloak.login({
            redirectUri: `${window.location.origin}`
          });
        }
      }),
      multi: true,
      deps: [KeycloakService]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
